import { Link } from "react-router-dom";
import { channels } from "@/mocks/news";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">爆料官网</span>
            </div>
            <p className="mt-4 max-w-md font-body text-sm leading-7 text-background-300">
              今日发布频道，聚合头条新闻、最新动态与今日聚焦内容。我们坚持多方核实、标注信源、拒绝标题党，
              让每一条爆料都经得起回看。
            </p>
            <p className="mt-5 flex flex-wrap items-center gap-3 font-label text-xs text-background-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-mail-line" aria-hidden="true"></i>
                tips@baoliao-today.example.com
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line" aria-hidden="true"></i>
                每日 08:00 / 20:00 更新
              </span>
            </p>
          </div>

          <nav className="md:col-span-3" aria-label="频道导航">
            <h4 className="font-heading text-sm font-semibold text-background-50">频道导航</h4>
            <ul className="mt-4 space-y-3">
              {channels.map((channel) => (
                <li key={channel.slug}>
                  <Link
                    to={`/channel/${channel.slug}`}
                    className="font-label text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {channel.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="md:col-span-2" aria-label="站点信息">
            <h4 className="font-heading text-sm font-semibold text-background-50">站点信息</h4>
            <ul className="mt-4 space-y-3">
              <li>
                <Link
                  to="/"
                  className="font-label text-sm text-background-300 transition-colors hover:text-primary-300"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/channel/all"
                  className="font-label text-sm text-background-300 transition-colors hover:text-primary-300"
                >
                  全部爆料
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="font-label text-sm text-background-300 transition-colors hover:text-primary-300"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about#submit"
                  className="font-label text-sm text-background-300 transition-colors hover:text-primary-300"
                >
                  线索投稿
                </Link>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50">内容原则</h4>
            <ul className="mt-4 space-y-3 font-label text-sm text-background-300">
              <li>多方核实</li>
              <li>标注信源</li>
              <li>尊重隐私</li>
              <li>接受更正</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-400">
            © 2026 爆料官网 · 本站内容为资讯汇编，相关细节请以当事方官方发布为准。
          </p>
          <p className="flex flex-wrap items-center gap-4 font-label text-xs text-background-400">
            <span>理性吃瓜</span>
            <span className="hidden h-3 w-px bg-background-700 sm:block"></span>
            <span>拒绝网络暴力</span>
            <span className="hidden h-3 w-px bg-background-700 sm:block"></span>
            <span>侵权联系删除</span>
          </p>
        </div>
      </div>
    </footer>
  );
}